import React from 'react';
import Navigation from './Navigation';

const PurchasesPage = ({ 
  currentUser, 
  currentPage, 
  setCurrentPage, 
  cart, 
  logout, 
  purchases 
}) => {
  const totalSpent = purchases.reduce((sum, item) => sum + item.price, 0);

  return (
    <div className="container">
      <div className="header">
        <h1>🌱 EcoFinds</h1>
        <Navigation 
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          cart={cart}
          logout={logout}
        />
      </div>
      
      <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px'}}>
        <h2>Purchase History ({purchases.length} items)</h2>
        {purchases.length > 0 && (
          <div style={{textAlign: 'right'}}>
            <p style={{color: '#666'}}>Total Spent</p>
            <p style={{fontSize: '20px', fontWeight: 'bold', color: '#2c5530'}}>
              ${totalSpent.toFixed(2)}
            </p>
          </div>
        )}
      </div>
      
      {purchases.length === 0 ? (
        <div className="form">
          <p>You haven't made any purchases yet.</p>
          <p>Start shopping to build your purchase history!</p>
          <button onClick={() => setCurrentPage('browse')}>
            Browse Products
          </button>
        </div>
      ) : (
        <div className="products-grid">
          {purchases.map((item, index) => (
            <div key={index} className="product-card">
              <div className="img">📷 Image Placeholder</div>
              <h3>{item.title}</h3>
              <p className="price">${item.price}</p>
              <p><strong>Category:</strong> {item.category}</p>
              <p style={{fontSize: '14px', color: '#666', marginBottom: '10px'}}>
                {item.description.substring(0, 80)}...
              </p>
              <p style={{fontSize: '12px', color: '#2c5530', fontWeight: 'bold'}}>
                Purchased: {item.purchaseDate?.toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: 'short',
                  day: 'numeric'
                })}
              </p>
              <div style={{marginTop: '10px', padding: '8px', background: '#e8f5e8', borderRadius: '4px'}}>
                <p style={{fontSize: '12px', color: '#2e7d32', margin: 0}}>
                  ✓ Purchase Complete
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PurchasesPage;